import React, { useEffect } from "react";

import Referrals from "../../../../../components/modules/referrals/Referrals";
import Navigation from "../../../../../components/navigations/client/detail/medical/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/medical/referrals");
  }, []);

  return (
    <Navigation activeTab="referrals" _case={_case}>
      <Referrals caseInfo={_case} />
    </Navigation>
  );
};
